import { render, staticRenderFns } from "./ComGoods.vue?vue&type=template&id=03034329&scoped=true&"
import script from "./ComGoods.vue?vue&type=script&lang=js&"
export * from "./ComGoods.vue?vue&type=script&lang=js&"
import style0 from "./ComGoods.vue?vue&type=style&index=0&id=03034329&prod&lang=css&"
import style1 from "./ComGoods.vue?vue&type=style&index=1&id=03034329&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03034329",
  null
  
)

export default component.exports